export const getValueWithCurrency = (currency: string, value: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(value)

export const getCurrencySymbol = (currency: string, locale = 'en-US'): string => {
  if (!currency) return ''
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
  })

  const parts = formatter.formatToParts(0)
  const currencyPart = parts.find((p) => p.type === 'currency')

  return currencyPart?.value ?? currency
}
